import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../actions';
import Link from 'react-router/lib/Link';
import CreditCardInfo from '../components/CreditCardInfo';
import withRouter from 'react-router/lib/withRouter';
import _ from 'lodash';

class Billing extends Component {
	
    state = {
        first: '',
        last: '',
        addr1: '',
        addr2: '',
        gender: '',
        bod: '',
        city: '',
        state: '',
        zip: '',
        country: '',
        phone: '',
        cc: '',
        cvv: '',
        exp_year: '',
        exp_month: '',
        promo_code: '',
        fitter_code: ''
    }

    componentWillMount() {
    	const { getProfileInfo } = this.props;
    	getProfileInfo();
    }

    componentWillReceiveProps(nextProps) {
    	this.setState(nextProps.profile);
    }

    changeValue = (e) => {
        const nextState = {};
        const { name, value } = e.target;
        nextState[name] = value;
        this.setState(nextState);
    }

    submit = (e) => {
    	e.preventDefault();
        try {
            const { payment, params } = this.props;
            const { username } = JSON.parse(sessionStorage.getItem('profile'));

            if(_.isNil(params.product)) {
                const fitterData = Object.assign({}, this.state, {
                    username,
                    vanity: username,
                    product: params.username
                })
                return payment(fitterData);
            }

            const newData = Object.assign({}, this.state, {
                username: params.username,
                vanity: params.username,
                product: params.product
            })
            payment(newData);
        } catch(error) {
            console.log(error);
        }	
    }

    render(){

        const { profile } = this.props;

		return (
			<div className="page_content">
				<div className="panel-custom-wrapper">
	                <div className="panel panel-custom">
	                    <div className="panel-heading">
	                        Payment
	                    </div>
	                    <form onSubmit={this.submit}>
	                    	<div className="panel-body">
	                            <div className="row">
	                                <div className="col-md-6 col-xs-12">
	                                    <div className="form-group">
	                                        <label>Last Name</label>
	                                        <input
	                                            value={this.state.last} 
	                                            onChange={this.changeValue}
	                                            type="text"
	                                            name="last" 
	                                            className="form-control form-custom"/>
	                                    </div>
	                                </div>
	                                <div className="col-md-6 col-xs-12">
	                                    <label>First Name</label>
	                                    <input
	                                        value={this.state.first} 
	                                        onChange={this.changeValue}
	                                        type="text"
	                                        name="first" 
	                                        className="form-control form-custom"/>
	                                </div>
	                            </div>

	                            <div className="row">
	                                <div className="col-md-6 col-xs-12">
	                                    <div className="form-group">
	                                        <label>Gender</label>
	                                        <select 
	                                            name="gender" 
	                                            value={this.state.gender} 
	                                            onChange={this.changeValue}
	                                            className="form-control form-custom">
	                                            <option value=""></option>
	                                            <option value="male">MALE</option>
	                                            <option value="female">FEMALE</option>
	                                        </select>
	                                    </div>
	                                </div>
	                                <div className="col-md-6 col-xs-12">
	                                    <div className="form-group">
	                                        <label>Birthdate (YYYY-MM-DD)</label>
	                                        <input
	                                            value={this.state.bod} 
	                                            onChange={this.changeValue}
	                                            type="text"
	                                            name="bod" 
	                                            className="form-control form-custom"/>
	                                    </div>
	                                </div>
	                            </div>

	                            <div className="row">
	                                <div className="col-md-6 col-xs-12">
	                                    <div className="form-group">
	                                        <label>Address 1</label>
	                                        <input
	                                            value={this.state.addr1} 
	                                            onChange={this.changeValue}
	                                            type="text"
	                                            name="addr1" 
	                                            className="form-control form-custom"/>
	                                    </div>
	                                </div>
	                                <div className="col-md-6 col-xs-12">
	                                    <div className="form-group">
	                                        <label>City</label>
	                                        <input
	                                            value={this.state.city} 
	                                            onChange={this.changeValue}
	                                            type="text"
	                                            name="city" 
	                                            className="form-control form-custom"/>
	                                    </div>
	                                </div>
	                            </div>

	                            <div className="row">
	                                <div className="col-md-6 col-xs-12">
	                                    <div className="form-group">
	                                        <label>State</label>
	                                        <input
	                                            value={this.state.state} 
	                                            onChange={this.changeValue}
	                                            type="text"
	                                            name="state" 
	                                            className="form-control form-custom"/>
	                                    </div>
	                                </div>
	                                <div className="col-md-6 col-xs-12">
	                                    <div className="form-group">
	                                        <label>Zip</label>
	                                        <input
	                                            value={this.state.zip} 
	                                            onChange={this.changeValue}
	                                            type="text"
	                                            name="zip" 
	                                            className="form-control form-custom"/>
	                                    </div>
	                                </div>
	                            </div>

	                            <div className="row">
	                                
	                                <div className="col-md-6 col-xs-12">
	                                    <div className="form-group">
	                                        <label>Country</label>
	                                        
	                                        <select 
	                                            name="country" 
	                                            value={this.state.country} 
	                                            onChange={this.changeValue}
	                                            className="form-control form-custom">
	                                            <option value=""></option>

	                                            { this.props.countries.map(item => {
	                                                return (
	                                                    <option key={`countries_${item.id}`} value={item.id}>
	                                                        { item.name }
	                                                    </option>
	                                                )
	                                            })}
	                                            
	                                        </select>
	                                    </div>
	                                </div>
	                                <div className="col-md-6 col-xs-12">
	                                    <div className="form-group">
	                                        <label>Phone</label>
	                                        <input
	                                            value={this.state.phone} 
	                                            onChange={this.changeValue}
	                                            type="text"
	                                            name="phone" 
	                                            className="form-control form-custom"/>
	                                    </div>
	                                </div>
	                            </div>

	                            <hr/>
                                { profile.is_fitter
                                    ? <div className="row">
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label>Fitter Code</label>
                                                <input
                                                    value={this.state.fitter_code} 
                                                    onChange={this.changeValue}
                                                    type="text"
                                                    name="fitter_code" 
                                                    className="form-control form-custom"/>
                                            </div>
                                        </div>
                                    </div>
                                    : <CreditCardInfo onChange={this.changeValue}/>
                                }

                        	</div>
	                    	<div className="btn-custom text-right panel-footer">
	                            <Link className="btn btn-primary" to="/profile/stance">Cancel</Link>&nbsp;&nbsp;
	                            <button className="btn btn-success" disabled={this.props.isWaiting}>
                                    { this.props.isWaiting 
                                        ? 'Loading...'
                                        : 'Proceed'
                                    }
                                </button>
	                        </div>
	                    </form>
	                </div>

	            </div>
            </div>
		)
	}
}

export default withRouter(connect(
	(state, routeParams) => {
		const { profile, countries } = state.profile;
        const { params } = routeParams;
        const { isWaiting } = state.onWaiting;
        
		return {
            profile,
            countries,
            params,
            isWaiting
		}
	},
	actions
)(Billing))


// WEBPACK FOOTER //
// ./src/billing/containers/Billing.js